import { Card, Flex, Typography } from 'antd';
import Highlighter from 'react-highlight-words';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import useIsMobile from '../../helpers/customHooks/useIsMobile';
import './index.less';

const { Title, Text } = Typography;

const IndexCard = ({ data, searchWords, style, onClick }) => {
	const isMobile = useIsMobile();

	return (
		<Card
			// key={key}
			style={{ ...style }}
			onClick={onClick}
			type="inner"
			className="search-index"
		>
			<Flex
				align="center"
				gap={8}
				// On phones every row reserves two title lines (see `.title` in index.less), so rows
				// whose name wraps are no taller than the rest.
				style={{ minHeight: isMobile ? 40 : 60 }}
			>
				<div style={{ textWrap: 'pretty' }}>
					<Title
						className="title"
						// style={{ fontWeight: 'normal', fontSize: 20, marginBlockEnd: 0 }}
						level={5}
						style={{ marginBottom: 0 }}
					>
						<Highlighter
							textToHighlight={data.full_name || data.name}
							searchWords={searchWords}
							autoEscape
							highlightStyle={{ background: 'none', color: '#0088FF' }}
						/>
						{data.building_floor_name && (
							<>, Floor {data.building_floor_name}</>
						)}
					</Title>

					{
						(data.building_name) &&
						<Text style={{ opacity: .65 }}>
							{data.building_name}
						</Text>
					}

					{(data.type_name) &&
						<Text
							style={{ opacity: .65 }}
							ellipsis
						>
							{data.type_name}
						</Text>
					}
					{
						(data.open || data.open === false) &&
						<Text style={{ color: data.open ? 'green' : 'red', display: 'block' }}>
							{data.open ? 'Open' : 'Close'}
						</Text>
					}
				</div>
				{
					// The whole row reads as a button on phones; the arrow only takes up room there.
					!isMobile &&
					<FontAwesomeIcon
						icon={faChevronRight}
						fontSize={12}
						style={{ marginLeft: 'auto' }}
					/>
				}
			</Flex>
		</Card>
	);
};

export default IndexCard;
